import { ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';

import { IInboundInvoiceIdentifier } from 'commons/types';
import {
  bulkRetryUpdateFailedInboundInvoice,
  retryUpdateFailedInboundInvoice,
} from 'redux-stores/actions';

import { IOpenBulkDialogData, IOpenDialogData } from '../types';

export const OpenDialogConfig: Record<string, IOpenDialogData | null> = {
  retry: {
    title: 'Submit Retry Update Failed Invoice',
    content: (invoiceNumber: string, inboundTaskNumber: string): string => {
      return `Are you sure to submit retry invoice ${invoiceNumber} for PO ${inboundTaskNumber}?`;
    },
    onConfirm: (
      dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
      invoiceNumber: string,
      inboundTaskNumber: string,
      location?: number,
    ): void => {
      dispatch(
        retryUpdateFailedInboundInvoice({
          invoiceNumber,
          inboundTaskNumber,
          location,
        }),
      );
    },
  },
};

export const OpenBulkDialogConfig: Record<string, IOpenBulkDialogData | null> =
  {
    Retry: {
      title: 'Submit Retry Update Failed Invoice',
      content: (invoiceIdentifiers: IInboundInvoiceIdentifier[]): string => {
        return `Are you sure to submit update retry for following invoices: \n\n ${invoiceIdentifiers
          .map(
            (invoiceIdentifier) =>
              `${invoiceIdentifier.invoice_number} (PO number: ${invoiceIdentifier.inbound_task_number})`,
          )
          .join('\n')}?`;
      },
      onConfirm: (
        dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
        invoiceIdentifiers: IInboundInvoiceIdentifier[],
        location?: number,
      ): void => {
        dispatch(
          bulkRetryUpdateFailedInboundInvoice({ invoiceIdentifiers, location }),
        );
      },
    },
  };
